/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useCreateClusterFormStyles = makeStyles(theme => ({
  planRoot: {
    marginBottom: '30px',
  },
  replicasWrapper: {
    display: 'flex',
  },
  replicasSlider: {
    flex: 1,
    maxWidth: '482px',
  },
  replicasPrice: {
    paddingLeft: '15px',
    display: 'flex',
    alignItems: 'center',
  },
  formControlLabel: {
    '& .MuiTypography-body1': {
      color: '#2C333B',
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  planContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '-8px -4px',
  },
  planItem: {
    padding: '8px 4px',
    '&$disabled': {
      opacity: '0.5',
      filter: 'blur(0.5px)',
      '& *': {
        cursor: 'default',
      },
    },
  },
  disabled: {},
  planLabel: {
    margin: '30px 0 20px 0',
    fontSize: '12px',
    lineHeight: '15px',

    '&:first-child': {
      margin: '0 0 20px 0',
    },
  },
  replicasLabel: {
    margin: '32px 0 14px 0',
    color: theme.palette.text.primary,
    fontSize: '12px',
    lineHeight: '15px',
  },
  price: {
    color: '#1F3F6D',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 500,
    cursor: 'pointer',
    '&:hover': {
      color: '#F16623',
    },
  },
}));
